import data from './data.svg';

export default function DataIcon() {
  return <img src={data} alt={'data'} width="32" height="32" />;
}
